(() => {
  'use strict';

  const config = window.PW_SEARCH_CONFIG || {};
  const root = document.querySelector(config.root || '#pw-search-test') || document.body;
  const apiBase = String(config.apiBase || '').replace(/\/$/, '');
  const placeholderImage = String(config.placeholderImage || '');
  const apiUrl = (path) => `${apiBase}${path}`;
  const linkTarget = config.sameOrigin ? '' : ' target="_blank" rel="noopener"';
  const collection = root.dataset.collectionType || '';
  const scopedSearch = root.dataset.scopedSearch === 'true';
  const collectionSort = root.dataset.collectionSort || '';
  const urlParams = new URLSearchParams(window.location.search);
  const urlQuery = urlParams.get('q') || '';
  const initialVendors = urlParams.getAll('vendor').map((value) => value.trim()).filter(Boolean);
  const parsedPage = Number.parseInt(urlParams.get('page') || '1', 10);
  const initialPage = Number.isFinite(parsedPage) && parsedPage > 0 ? Math.min(parsedPage, 5000) : 1;
  const initialQuery = root.dataset.initialQuery || urlQuery;
  const collectionSortMap = { manual: 'manual', 'best-selling': 'recent_best', best_selling: 'recent_best', 'created-descending': 'newest', created_desc: 'newest', 'price-ascending': 'price_asc', price_asc: 'price_asc', 'price-descending': 'price_desc', price_desc: 'price_desc', 'title-ascending': 'title', alpha_asc: 'title' };
  const initialSort = collection ? (collectionSortMap[collectionSort] || 'recent_best') : 'relevance';
  const state = { q: initialQuery, page: initialPage, limit: 24, sort: initialSort, collection, product_type: [], vendor: initialVendors, availability_key: [], series_name: [], cover: [], issue_number: [], cover_artists: [], writers: [], artists: [], price_min: '', price_max: '', release_from: '', release_to: '', foc_from: '', foc_to: '', view: localStorage.getItem('pw-search-view') || 'grid', facets: {} };
  let requestController;
  let priceTimer;
  let suggestTimer;
  let suggestController;
  let activeSuggestion = -1;
  let initialLoad = true;
  const facetTimers = {};
  const facetControllers = {};

  const $ = (selector) => root.querySelector(selector);
  const elements = {
    form: $('#search-form'), input: $('#search-input'), results: $('#results'), status: $('#status'), summary: $('#result-summary'), note: $('#query-note'), pagination: $('#pagination'),
    types: $('#product-type-facets'), vendors: $('#vendor-facets'), vendorFilter: $('#vendor-filter'), sort: $('#sort-select'), activeFilters: $('#active-filters'), filterToggle: $('#filter-toggle'),
    filters: $('#filters'), filterCount: $('#filter-count'), clear: $('#clear-filters'), mobileApply: $('#mobile-filter-apply'), priceMin: $('#price-min'), priceMax: $('#price-max'), releaseFrom: $('#release-from'), releaseTo: $('#release-to'), focFrom: $('#foc-from'), focTo: $('#foc-to'), grid: $('#grid-view'), list: $('#list-view'), typeahead: $('#typeahead')
  };
  // Collection and main-search sections use the single global header search.
  if (Object.prototype.hasOwnProperty.call(root.dataset, 'initialQuery') && elements.form && !scopedSearch) elements.form.hidden = true;
  const initialShopifyMarkup = elements.results?.classList.contains('pw-shopify-initial-results') ? elements.results.innerHTML : '';
  const initialShopifySummary = elements.summary?.textContent || '';
  if (elements.sort) elements.sort.value = initialSort;
  const urlArrays = ['product_type', 'vendor', 'availability_key', 'series_name', 'cover', 'issue_number', 'cover_artists', 'writers', 'artists'];
  const urlRanges = { price_min: elements.priceMin, price_max: elements.priceMax, release_from: elements.releaseFrom, release_to: elements.releaseTo, foc_from: elements.focFrom, foc_to: elements.focTo };
  const allowedSorts = [...elements.sort.options].map(option => option.value);
  function restoreScopedUrl() {
    const query = new URLSearchParams(window.location.search);
    state.q = query.get('q') || '';
    state.page = Math.min(5000, Math.max(1, Number.parseInt(query.get('page') || '1', 10) || 1));
    state.sort = allowedSorts.includes(query.get('sort')) ? query.get('sort') : initialSort;
    urlArrays.forEach(key => { state[key] = query.getAll(key).map(value => value.trim()).filter(Boolean); });
    Object.entries(urlRanges).forEach(([key, input]) => { input.value = query.get(key) || ''; state[key] = input.value; });
    elements.input.value = state.q;
    elements.sort.value = state.sort;
  }
  function writeScopedUrl() {
    const url = new URL(window.location.href);
    ['q', 'page', 'sort', ...urlArrays, ...Object.keys(urlRanges)].forEach(key => url.searchParams.delete(key));
    if (state.q) url.searchParams.set('q', state.q);
    if (state.page > 1) url.searchParams.set('page', String(state.page));
    if (state.sort !== initialSort) url.searchParams.set('sort', state.sort);
    urlArrays.forEach(key => state[key].forEach(value => url.searchParams.append(key, value)));
    Object.keys(urlRanges).forEach(key => { if (state[key]) url.searchParams.set(key, state[key]); });
    if (url.href !== window.location.href) window.history.pushState({ pwFoc: true }, '', url);
  }
  function hasScopedFilters() {
    return !!state.q || urlArrays.some(key => state[key].length) || Object.keys(urlRanges).some(key => state[key]);
  }
  if (scopedSearch) {
    restoreScopedUrl();
    root.querySelectorAll('[data-foc-vendor]').forEach(link => link.addEventListener('click', event => {
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      state.vendor = state.vendor.includes(link.dataset.focVendor) ? [] : [link.dataset.focVendor];
      state.page = 1;
      search({ preserveScroll: true });
    }));
    root.querySelector('[data-foc-clear]')?.addEventListener('click', () => {
      state.q = ''; elements.input.value = ''; resetFilters();
    });
  }
  if (!document.querySelector('#pw-search-runtime-styles')) {
    const runtimeStyles = document.createElement('style');
    runtimeStyles.id = 'pw-search-runtime-styles';
    runtimeStyles.textContent = '#pw-search-test.pw-shopify-fallback .catalogue{grid-template-columns:minmax(0,1fr)}#pw-search-test .filters[hidden],#pw-search-test .filter-toggle[hidden]{display:none!important}#pw-search-test .search-box>button{background:#ff2000}#pw-search-test .card-action:not(.pre-order):not(.sold-out){background:#00aa00}#pw-search-test .card-action.pre-order{background:#ff9900}@media(max-width:900px){#pw-search-test .filters{padding:15px}#pw-search-test .mobile-filter-apply{position:sticky;top:0;bottom:auto;z-index:4;width:calc(100% + 30px);margin:12px -15px 4px;background:#1e2d7d;box-shadow:0 8px 18px #fff}}';
    document.head.appendChild(runtimeStyles);
  }
  const facetElements = {
    product_type: elements.types,
    vendor: elements.vendors,
    availability_key: $('#availability-facets'),
    series_name: $('#series-name-facets'),
    cover: $('#cover-facets'),
    issue_number: $('#issue-number-facets'),
    cover_artists: $('#cover-artist-facets'),
    writers: $('#writer-facets'),
    artists: $('#artist-facets')
  };

  const escapeHtml = (value) => String(value ?? '').replace(/[&<>'"]/g, (char) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' })[char]);
  const safeHighlight = (value) => escapeHtml(value ?? '').replace(/&lt;mark&gt;/g, '<mark>').replace(/&lt;\/mark&gt;/g, '</mark>');
  const money = (value) => new Intl.NumberFormat('en-NZ', { style: 'currency', currency: 'NZD' }).format(Number(value || 0));
  const dateLabel = (value) => {
    if (!value) return '';
    const raw = String(value).trim();
    let date;
    if (/^\d{4}-\d{2}-\d{2}$/.test(raw)) date = new Date(`${raw}T00:00:00Z`);
    else {
      const us = raw.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
      date = us ? new Date(`${us[3]}-${us[1].padStart(2, '0')}-${us[2].padStart(2, '0')}T00:00:00Z`) : new Date(raw);
    }
    return Number.isNaN(date.getTime()) || date.getUTCFullYear() < 2000 ? '' : new Intl.DateTimeFormat('en-NZ', { day: 'numeric', month: 'short', year: 'numeric', timeZone: 'UTC' }).format(date);
  };
  const plural = (count, word) => `${Number(count).toLocaleString('en-NZ')} ${word}${count === 1 ? '' : 's'}`;

  function armImageFallbacks(container) {
    if (!container || !placeholderImage) return;
    container.querySelectorAll('img[data-pw-image-fallback]').forEach((image) => {
      image.addEventListener('error', () => {
        image.removeAttribute('srcset');
        image.src = placeholderImage;
        image.alt = 'Cover coming soon';
      }, { once: true });
    });
  }

  async function applyFacetConfiguration() {
    try {
      const response = await fetch(apiUrl('/api/config.php'));
      const data = await response.json();
      const settings = Array.isArray(data.facets) ? data.facets : [];
      if (!settings.length) return;
      const mobile = window.matchMedia('(max-width: 900px)').matches;
      settings.forEach((setting) => {
        const fieldset = elements.filters.querySelector(`[data-facet-id="${CSS.escape(setting.id)}"]`);
        if (!fieldset) return;
        fieldset.hidden = !setting.enabled;
        // Appending each configured fieldset in sequence guarantees the saved order.
        elements.filters.appendChild(fieldset);
        const legend = fieldset.querySelector('legend');
        if (!legend || legend.querySelector('button')) return;
        const label = setting.label || legend.textContent.trim();
        const open = mobile ? !!setting.mobile_open : !!setting.desktop_open;
        const button = document.createElement('button');
        button.type = 'button'; button.className = 'facet-collapse'; button.setAttribute('aria-expanded', String(open));
        button.innerHTML = `<span>${escapeHtml(label)}</span><span aria-hidden="true">⌄</span>`;
        legend.textContent = ''; legend.append(button);
        fieldset.classList.toggle('facet-collapsed', !open);
        button.addEventListener('click', () => {
          const nextOpen = fieldset.classList.toggle('facet-collapsed') === false;
          button.setAttribute('aria-expanded', String(nextOpen));
        });
      });
    } catch (_) { /* Defaults remain usable when config is unavailable. */ }
  }

  function params() {
    return Object.fromEntries(Object.entries(state).filter(([key, value]) => !['view', 'facets'].includes(key) && value !== '' && (!Array.isArray(value) || value.length)));
  }

  function setLoading() {
    elements.status.hidden = true;
    elements.results.setAttribute('aria-busy', 'true');
    if (initialLoad && initialShopifyMarkup) {
      elements.results.classList.add('pw-search-refreshing');
      return;
    }
    elements.results.innerHTML = Array.from({ length: 8 }, () => '<div class="loading-card"></div>').join('');
  }

  function renderCard(hit) {
    const formatted = hit._formatted || {};
    const image = hit.image
      ? `<img src="${escapeHtml(hit.image)}" alt="" loading="lazy" width="420" height="650"${placeholderImage ? ' data-pw-image-fallback' : ''}>`
      : (placeholderImage ? `<img src="${escapeHtml(placeholderImage)}" alt="Cover coming soon" loading="lazy" width="420" height="650">` : '<span class="image-fallback">PW</span>');
    const hasSaving = Number(hit.compare_at_price) > Number(hit.min_price);
    const saving = hasSaving ? Math.round((1 - Number(hit.min_price) / Number(hit.compare_at_price)) * 100) : 0;
    const status = hit.availability_key || (hit.in_stock ? 'in_stock' : 'out_of_stock');
    const stockLabel = status === 'in_stock'
      ? (Number(hit.inventory_quantity) === 1 ? 'Only 1 left' : 'In Stock')
      : (status === 'pre_order' ? 'Pre-Order' : (status === 'special_order' ? 'Special Order' : 'Out of Stock'));
    const shippingText = status === 'in_stock'
      ? 'Ships Fastest'
      : (status === 'special_order' ? 'Usually ships in 3–6 weeks' : '');
    const showDates = status === 'pre_order';
    const dates = showDates
      ? [hit.release_date ? `<span><b>Release:</b> ${dateLabel(hit.release_date)}</span>` : '', hit.foc_date ? `<span><b>FOC:</b> ${dateLabel(hit.foc_date)}</span>` : ''].filter(Boolean).join('')
      : '';
    const buttonClass = status === 'pre_order' ? 'pre-order' : (status === 'out_of_stock' ? 'sold-out' : '');
    const buttonText = status === 'in_stock' ? 'Add to cart' : (status === 'pre_order' ? 'Pre-Order' : (status === 'special_order' ? 'Special Order' : 'Sold Out'));
    const isPreOwned = ['pre-owned comics', 'pre-owned graphic novels'].includes(String(hit.product_type || '').trim().toLowerCase());
    const cartProperties = status === 'in_stock'
      ? '<input type="hidden" name="properties[In Stock]" value="Ready To Ship">'
      : `${hit.foc_date ? `<input type="hidden" name="properties[FOC Date]" value="${escapeHtml(hit.foc_date)}">` : ''}${hit.release_date ? `<input type="hidden" name="properties[Release Date]" value="Est. ${escapeHtml(hit.release_date)}">` : ''}`;
    const action = isPreOwned
      ? `<a class="card-action" href="${escapeHtml(hit.url)}"${linkTarget}>View Item</a>`
      : status === 'in_stock' || status === 'pre_order'
      ? `<form class="card-cart-form" method="post" action="${escapeHtml(config.cartAction || 'https://popweasel.co.nz/cart/add')}"${config.sameOrigin ? '' : ' target="_blank"'}><input type="hidden" name="id" value="${escapeHtml(hit.primary_variant_id)}"><input type="hidden" name="quantity" value="1">${cartProperties}<button class="card-action ${buttonClass}" data-action="pw-add-to-cart" type="submit">${buttonText}</button></form>`
      : (status === 'special_order' ? `<a class="card-action" href="${escapeHtml(hit.url)}"${linkTarget}>${buttonText}</a>` : `<button class="card-action sold-out" type="button" disabled>${buttonText}</button>`);
    const wishlist = `<button type="button" class="pw-wishlist-button pw-wishlist-button--icon" data-wishlist-button data-product-id="${escapeHtml(hit.id)}" data-variant-id="${escapeHtml(hit.primary_variant_id || '')}" data-product-handle="${escapeHtml(hit.handle || '')}" aria-pressed="false" aria-label="Add ${escapeHtml(hit.title || 'item')} to wishlist"><svg aria-hidden="true" viewBox="0 0 24 24" width="22" height="22"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78L12 21.23l8.84-8.84a5.5 5.5 0 0 0 0-7.78Z"/></svg><span class="visually-hidden" data-wishlist-label>Add to wishlist</span></button>`;
    return `<article class="product-card" data-product-id="${escapeHtml(hit.id)}">
      <div class="product-image product-item__image-wrapper" data-product-id="${escapeHtml(hit.id)}" data-variant-id="${escapeHtml(hit.primary_variant_id || '')}">${image}${saving > 0 ? `<span class="sale-badge">Save ${saving}%</span>` : ''}${wishlist}</div>
      <div class="product-info">
        <div class="price-ticket"><span class="price">${money(hit.min_price)}</span>${hasSaving ? `<span class="ticket-price"><small>TICKET:</small><span>${money(hit.compare_at_price)}</span></span>` : ''}</div>
        <p class="product-type">${hit.vendor ? `<a class="brand-link" href="/search?vendor=${encodeURIComponent(hit.vendor)}">${safeHighlight(formatted.vendor || hit.vendor)}</a>` : safeHighlight(formatted.product_type || hit.product_type || 'Product')}</p>
        <h3><a href="${escapeHtml(hit.url)}"${linkTarget}>${safeHighlight(formatted.title || hit.title)}</a></h3>
        <p class="stock-line status-${escapeHtml(status)}"><span class="stock-badge">${escapeHtml(stockLabel)}</span>${shippingText ? `<span class="shipping-text">${escapeHtml(shippingText)}</span>` : ''}</p>
        ${dates ? `<div class="product-dates">${dates}</div>` : ''}
        ${action}
      </div>
    </article>`;
  }

  function closeTypeahead() {
    elements.typeahead.hidden = true;
    elements.typeahead.innerHTML = '';
    activeSuggestion = -1;
  }

  function renderTypeahead(data, query) {
    const items = data.suggestions || [];
    const collections = data.collections || [];
    const queries = data.queries || [];
    if (!items.length && !collections.length && !queries.length) { closeTypeahead(); return; }
    let index = 0;
    const queryHtml = queries.length ? `<div class="typeahead-section"><b>Suggestions</b>${queries.map((item) => `<button type="button" class="typeahead-query" data-global-query="${escapeHtml(item.text)}"><span>Search for “${safeHighlight(String(item.styled_text || item.text).replace(/<\/?span>/gi, ''))}”</span><span class="typeahead-query-action">Search →</span></button>`).join('')}</div>` : '';
    const collectionHtml = collections.length ? `<div class="typeahead-section"><b>Collections</b>${collections.map((item) => `<a class="typeahead-collection" href="${escapeHtml(item.url)}"${linkTarget}>${escapeHtml(item.title)}<span>Collection →</span></a>`).join('')}</div>` : '';
    const productHtml = items.length ? `<div class="typeahead-section"><b>Products</b>${items.map((hit) => {
      const needle = query.toLowerCase().replace(/\s+/g, '');
      const sku = (hit.sku || []).find((value) => String(value).toLowerCase().replace(/\s+/g, '').includes(needle));
      const barcode = (hit.barcode || []).find((value) => String(value).toLowerCase().replace(/\s+/g, '').includes(needle));
      const identifier = sku ? `SKU: ${sku}` : (barcode ? `Barcode: ${barcode}` : '');
      return `<a class="typeahead-item" role="option" data-suggestion="${index++}" href="${escapeHtml(hit.url)}">
      <span class="typeahead-image">${hit.image ? `<img src="${escapeHtml(hit.image)}" alt=""${placeholderImage ? ' data-pw-image-fallback' : ''}>` : (placeholderImage ? `<img src="${escapeHtml(placeholderImage)}" alt="Cover coming soon">` : 'PW')}</span>
      <span class="typeahead-copy"><strong>${safeHighlight(hit._formatted?.title || hit.title)}</strong><small>${identifier ? `${escapeHtml(identifier)} · ` : ''}${escapeHtml(hit.vendor || hit.product_type || '')} · ${money(hit.min_price)}${hit.in_stock ? ' · In stock' : ''}</small></span>
    </a>`; }).join('')}</div>` : '';
    elements.typeahead.innerHTML = queryHtml + collectionHtml + productHtml + `<button class="typeahead-all" type="button" data-search-all>See all results for “${escapeHtml(query)}” →</button>`;
    armImageFallbacks(elements.typeahead);
    elements.typeahead.hidden = false;
    activeSuggestion = -1;
  }

  async function fetchSuggestions() {
    if (scopedSearch) return; // Global suggestions are not scoped to this FOC collection.
    const query = elements.input.value.trim();
    if (query.length < 2) { closeTypeahead(); return; }
    suggestController?.abort();
    suggestController = new AbortController();
    try {
      const response = await fetch(apiUrl(`/api/suggest.php?q=${encodeURIComponent(query)}`), { signal: suggestController.signal });
      const data = await response.json();
      if (query === elements.input.value.trim()) renderTypeahead(data, query);
    } catch (error) {
      if (error.name !== 'AbortError') closeTypeahead();
    }
  }

  function renderFacets(container, field, values, filter = '') {
    const selected = new Set(state[field]);
    const availabilityOrder = { in_stock: 0, pre_order: 1, special_order: 2, out_of_stock: 3 };
    const rows = Object.entries(values || {}).filter(([name]) => name.toLowerCase().includes(filter.toLowerCase())).sort((a, b) => field === 'availability_key'
      ? (availabilityOrder[a[0]] ?? 99) - (availabilityOrder[b[0]] ?? 99)
      : (field === 'issue_number' ? Number(a[0]) - Number(b[0]) : b[1] - a[1] || a[0].localeCompare(b[0]))).slice(0, 60);
    const labels = { in_stock: 'In Stock', pre_order: 'Pre-Order', special_order: 'Special Order', out_of_stock: 'Out of Stock' };
    container.classList.remove('skeleton-lines');
    container.innerHTML = rows.length ? rows.map(([name, count]) => `<label title="${escapeHtml(labels[name] || name)}"><span class="facet-label"><input type="checkbox" data-facet="${field}" value="${escapeHtml(name)}" ${selected.has(name) ? 'checked' : ''}><span>${escapeHtml(labels[name] || name)}</span></span><span class="facet-count">${count}</span></label>`).join('') : '<small>No matching options</small>';
  }

  async function searchFacet(input) {
    const field = input.dataset.facetSearch;
    const query = input.value.trim();
    const container = facetElements[field];
    if (!container) return;
    if (query === '') { renderFacets(container, field, state.facets[field]); return; }
    facetControllers[field]?.abort();
    facetControllers[field] = new AbortController();
    try {
      const response = await fetch(apiUrl(`/api/facets.php?field=${encodeURIComponent(field)}&q=${encodeURIComponent(query)}`), { signal: facetControllers[field].signal });
      const data = await response.json();
      if (query !== input.value.trim()) return;
      const values = Object.fromEntries((data.hits || []).map((hit) => [hit.value, hit.count]));
      renderFacets(container, field, values);
    } catch (error) {
      if (error.name !== 'AbortError') renderFacets(container, field, {}, query);
    }
  }

  function renderActiveFilters() {
    const chips = [];
    const facetLabels = { product_type: 'Type', vendor: 'Brand', availability_key: 'Availability', series_name: 'Series', cover: 'Cover', issue_number: 'Issue', cover_artists: 'Cover artist', writers: 'Writer', artists: 'Artist' };
    Object.entries(facetLabels).forEach(([field, label]) => state[field].forEach((value) => chips.push([`${label}: ${value}`, field, value])));
    if (state.price_min) chips.push([`From ${money(state.price_min)}`, 'price_min', state.price_min]);
    if (state.price_max) chips.push([`Up to ${money(state.price_max)}`, 'price_max', state.price_max]);
    if (state.release_from) chips.push([`Release from ${dateLabel(state.release_from)}`, 'release_from', state.release_from]);
    if (state.release_to) chips.push([`Release to ${dateLabel(state.release_to)}`, 'release_to', state.release_to]);
    if (state.foc_from) chips.push([`FOC from ${dateLabel(state.foc_from)}`, 'foc_from', state.foc_from]);
    if (state.foc_to) chips.push([`FOC to ${dateLabel(state.foc_to)}`, 'foc_to', state.foc_to]);
    elements.activeFilters.innerHTML = chips.map(([label, field, value]) => `<button class="filter-chip" type="button" data-remove="${field}" data-value="${escapeHtml(value)}">${escapeHtml(label)} ×</button>`).join('');
    elements.filterCount.textContent = chips.length ? `(${chips.length})` : '';
  }

  function renderPagination(page, totalPages) {
    if (totalPages <= 1) { elements.pagination.innerHTML = ''; return; }
    const pages = [...new Set([1, page - 1, page, page + 1, totalPages].filter((value) => value >= 1 && value <= totalPages))].sort((a, b) => a - b);
    const pageUrl = (value) => {
      const url = new URL(window.location.href);
      if (value <= 1) url.searchParams.delete('page');
      else url.searchParams.set('page', String(value));
      return `${url.pathname}${url.search}${url.hash}`;
    };
    let previous = 0;
    const items = pages.map((value) => {
      const gap = value - previous > 1 ? '<span>…</span>' : '';
      previous = value;
      return `${gap}<a href="${escapeHtml(pageUrl(value))}" data-page="${value}" class="${value === page ? 'active' : ''}"${value === page ? ' aria-current="page"' : ''}>${value}</a>`;
    }).join('');
    const previousLink = page === 1
      ? '<span class="disabled" aria-hidden="true">←</span>'
      : `<a href="${escapeHtml(pageUrl(page - 1))}" data-page="${page - 1}" aria-label="Previous page">←</a>`;
    const nextLink = page === totalPages
      ? '<span class="disabled" aria-hidden="true">→</span>'
      : `<a href="${escapeHtml(pageUrl(page + 1))}" data-page="${page + 1}" aria-label="Next page">→</a>`;
    elements.pagination.innerHTML = `${previousLink}${items}${nextLink}`;
  }

  async function search({ preserveScroll = false, history = true } = {}) {
    if (scopedSearch) {
      if (history) writeScopedUrl();
      root.querySelectorAll('[data-foc-vendor]').forEach(link => {
        link.setAttribute('aria-current', String(state.vendor.includes(link.dataset.focVendor)));
      });
    }
    requestController?.abort();
    requestController = new AbortController();
    setLoading();
    renderActiveFilters();
    const started = performance.now();
    try {
      const response = await fetch(apiUrl('/api/search.php'), { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(params()), signal: requestController.signal });
      const data = await response.json();
      if (!response.ok) throw new Error(data.error || 'Search failed');
      if (collection && initialLoad && !data.hits.length && initialShopifyMarkup && (!scopedSearch || !hasScopedFilters())) {
        elements.results.innerHTML = initialShopifyMarkup;
        elements.summary.textContent = initialShopifySummary;
        elements.results.classList.remove('pw-search-refreshing');
        elements.results.setAttribute('aria-busy', 'false');
        elements.status.hidden = true;
        elements.status.textContent = '';
        elements.filters.hidden = true;
        elements.filterToggle.hidden = true;
        elements.sort.disabled = true;
        root.classList.add('pw-shopify-fallback');
        initialLoad = false;
        return;
      }
      state.facets = data.facetDistribution || {};
      elements.filters.hidden = false;
      elements.filterToggle.hidden = false;
      elements.sort.disabled = false;
      root.classList.remove('pw-shopify-fallback');
      Object.entries(facetElements).forEach(([field, container]) => {
        if (!container) return;
        const searchInput = root.querySelector(`[data-facet-search="${field}"]`);
        renderFacets(container, field, state.facets[field], searchInput?.value || (field === 'vendor' ? elements.vendorFilter.value : ''));
      });
      elements.results.innerHTML = data.hits.length ? data.hits.map(renderCard).join('') : '';
      armImageFallbacks(elements.results);
      initialLoad = false;
      elements.results.classList.remove('pw-shopify-initial-results', 'pw-search-refreshing');
      elements.results.setAttribute('aria-busy', 'false');
      elements.results.classList.toggle('list-view', state.view === 'list');
      elements.summary.textContent = data.hits.length ? plural(data.estimatedTotalHits || 0, 'result') : 'No products found';
      if (elements.mobileApply) elements.mobileApply.textContent = data.hits.length ? `View ${plural(data.estimatedTotalHits || 0, 'result')}` : 'View results';
      const elapsedSeconds = ((performance.now() - started) / 1000).toFixed(2);
      elements.note.textContent = state.q ? `for “${state.q}” · ${elapsedSeconds} seconds` : `${elapsedSeconds} seconds`;
      if (!data.hits.length) { elements.status.hidden = false; elements.status.textContent = 'Try a broader search or clear one of the filters.'; }
      renderPagination(data.page, data.totalPages);
      if (!preserveScroll && state.page > 1) root.querySelector('.results-area').scrollIntoView({ behavior: 'smooth', block: 'start' });
    } catch (error) {
      if (error.name === 'AbortError') return;
      const restoredShopifyFallback = initialLoad && !!initialShopifyMarkup && (!scopedSearch || !hasScopedFilters());
      if (restoredShopifyFallback) {
        elements.results.innerHTML = initialShopifyMarkup;
        elements.summary.textContent = initialShopifySummary;
        elements.results.classList.remove('pw-search-refreshing');
      } else {
        elements.results.innerHTML = '';
        elements.summary.textContent = 'Search unavailable';
      }
      initialLoad = false;
      elements.results.setAttribute('aria-busy', 'false');
      elements.status.hidden = restoredShopifyFallback;
      elements.status.textContent = restoredShopifyFallback ? '' : 'Search is temporarily unavailable. Please try again.';
      if (restoredShopifyFallback) {
        elements.filters.hidden = true;
        elements.filterToggle.hidden = true;
        elements.sort.disabled = true;
        root.classList.add('pw-shopify-fallback');
      }
    }
  }

  function resetFilters() {
    Object.assign(state, { page: 1, product_type: [], vendor: [], availability_key: [], series_name: [], cover: [], issue_number: [], cover_artists: [], writers: [], artists: [], price_min: '', price_max: '', release_from: '', release_to: '', foc_from: '', foc_to: '' });
    elements.priceMin.value = '';
    elements.priceMax.value = '';
    [elements.releaseFrom, elements.releaseTo, elements.focFrom, elements.focTo].forEach((input) => { input.value = ''; });
    search({ preserveScroll: true });
  }

  function updateView(view) {
    state.view = view;
    localStorage.setItem('pw-search-view', view);
    elements.results.classList.toggle('list-view', view === 'list');
    elements.grid.classList.toggle('active', view === 'grid');
    elements.list.classList.toggle('active', view === 'list');
    elements.grid.setAttribute('aria-pressed', String(view === 'grid'));
    elements.list.setAttribute('aria-pressed', String(view === 'list'));
  }

  elements.form.addEventListener('submit', (event) => { event.preventDefault(); closeTypeahead(); state.q = elements.input.value.trim(); state.page = 1; search({ preserveScroll: true }); });
  elements.input.addEventListener('input', () => { clearTimeout(suggestTimer); suggestTimer = setTimeout(fetchSuggestions, 180); });
  elements.input.addEventListener('keydown', (event) => {
    const options = [...elements.typeahead.querySelectorAll('[data-suggestion]')];
    if (elements.typeahead.hidden || !options.length) return;
    if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
      event.preventDefault();
      activeSuggestion = event.key === 'ArrowDown' ? (activeSuggestion + 1) % options.length : (activeSuggestion - 1 + options.length) % options.length;
      options.forEach((option, index) => option.classList.toggle('active', index === activeSuggestion));
      options[activeSuggestion].scrollIntoView({ block: 'nearest' });
    } else if (event.key === 'Enter' && activeSuggestion >= 0) {
      event.preventDefault();
      window.location.href = options[activeSuggestion].href;
    } else if (event.key === 'Escape') closeTypeahead();
  });
  elements.typeahead.addEventListener('click', (event) => { const queryButton = event.target.closest('[data-global-query]'); if (queryButton) { event.preventDefault(); elements.input.value = queryButton.dataset.globalQuery; state.q = queryButton.dataset.globalQuery; state.page = 1; closeTypeahead(); search({ preserveScroll: true }); return; } if (event.target.closest('[data-search-all]')) { event.preventDefault(); state.q = elements.input.value.trim(); state.page = 1; closeTypeahead(); search({ preserveScroll: true }); } });
  document.addEventListener('click', (event) => { if (!elements.form.contains(event.target)) closeTypeahead(); });
  elements.filters.addEventListener('change', (event) => { const input = event.target; if (input.dataset.facet) { const values = new Set(state[input.dataset.facet]); input.checked ? values.add(input.value) : values.delete(input.value); state[input.dataset.facet] = [...values]; } state.page = 1; search({ preserveScroll: true }); });
  root.querySelectorAll('[data-facet-search]').forEach((input) => input.addEventListener('input', () => { const field = input.dataset.facetSearch; clearTimeout(facetTimers[field]); facetTimers[field] = setTimeout(() => searchFacet(input), 180); }));
  [elements.priceMin, elements.priceMax].forEach((input) => input.addEventListener('input', () => { clearTimeout(priceTimer); priceTimer = setTimeout(() => { state.price_min = elements.priceMin.value; state.price_max = elements.priceMax.value; state.page = 1; search({ preserveScroll: true }); }, 450); }));
  [elements.releaseFrom, elements.releaseTo, elements.focFrom, elements.focTo].forEach((input) => input.addEventListener('change', () => { state.release_from = elements.releaseFrom.value; state.release_to = elements.releaseTo.value; state.foc_from = elements.focFrom.value; state.foc_to = elements.focTo.value; state.page = 1; search({ preserveScroll: true }); }));
  elements.sort.addEventListener('change', () => { state.sort = elements.sort.value; state.page = 1; search({ preserveScroll: true }); });
  elements.pagination.addEventListener('click', (event) => {
    const link = event.target.closest('a[data-page]');
    if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    state.page = Number(link.dataset.page);
    if (!scopedSearch) window.history.pushState({ pwSearchPage: state.page }, '', link.href);
    search();
  });
  window.addEventListener('popstate', () => {
    if (scopedSearch) {
      restoreScopedUrl();
      search({ preserveScroll: true, history: false });
      return;
    }
    const page = Number.parseInt(new URLSearchParams(window.location.search).get('page') || '1', 10);
    state.page = Number.isFinite(page) && page > 0 ? Math.min(page, 5000) : 1;
    search({ preserveScroll: true });
  });
  elements.activeFilters.addEventListener('click', (event) => { const button = event.target.closest('[data-remove]'); if (!button) return; const field = button.dataset.remove; if (Array.isArray(state[field])) state[field] = state[field].filter((value) => value !== button.dataset.value); else state[field] = ''; if (field === 'price_min') elements.priceMin.value = ''; if (field === 'price_max') elements.priceMax.value = ''; const dateInputs = { release_from: elements.releaseFrom, release_to: elements.releaseTo, foc_from: elements.focFrom, foc_to: elements.focTo }; if (dateInputs[field]) dateInputs[field].value = ''; state.page = 1; search({ preserveScroll: true }); });
  elements.clear.addEventListener('click', resetFilters);
  elements.filterToggle.addEventListener('click', () => { const open = elements.filters.classList.toggle('open'); elements.filterToggle.setAttribute('aria-expanded', String(open)); });
  elements.mobileApply?.addEventListener('click', () => { elements.filters.classList.remove('open'); elements.filterToggle.setAttribute('aria-expanded', 'false'); elements.filterToggle.scrollIntoView({ behavior: 'smooth', block: 'start' }); });
  elements.grid.addEventListener('click', () => updateView('grid'));
  elements.list.addEventListener('click', () => updateView('list'));

  updateView(state.view);
  applyFacetConfiguration().finally(() => search({ preserveScroll: true }));
})();
